import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetFilters } from '../../store/Reducers/OrderRerunsSlice';
import { OrderRerunsDatagrid } from '../../components/DataGrid/OrderReruns/OrderRerunsDatagrid';

export const OrderRerunsPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetFilters());
    };
  }, [dispatch]);

  return <OrderRerunsDatagrid />;
};
